import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Eye, EyeOff, KeyRound, ShieldCheck } from "lucide-react";
import { publicApi, auth } from "@/lib/api";
import { EntryBackLink, EntryBrand, EntryDivider, EntryVaultShell } from "@/components/entry/EntryExperience";

export default function AdminGate() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isSetup, setIsSetup] = useState(false);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let active = true;
    publicApi.get("/admin/setup-status").then(({ data }) => { if (active) setIsSetup(data.is_setup); })
      .catch(() => { if (active) toast.error("تعذّر الاتصال بالخادم"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    if (!pw || pw.length < 4) return toast.error("كلمة المرور قصيرة جداً (4 أحرف على الأقل)");
    if (!isSetup && pw !== pw2) return toast.error("كلمتا المرور غير متطابقتين");
    setSubmitting(true);
    try {
      const { data } = await publicApi.post(isSetup ? "/admin/login" : "/admin/setup", { password: pw });
      auth.setAdmin(data.token);
      toast.success(isSetup ? "أهلاً بعودتك" : "تم إنشاء حساب المدير");
      nav("/admin/dashboard");
    } catch (error) { toast.error(error?.response?.data?.detail || "حدث خطأ"); }
    finally { setSubmitting(false); }
  };

  const title = loading ? "جاري التحقق…" : isSetup ? "دخول المدير" : "إعداد كلمة مرور المدير";
  return <EntryVaultShell><section className="entry-admin"><div className="entry-admin__top"><EntryBackLink to="/" testId="admin-back-home">العودة للرئيسية</EntryBackLink></div><div className="entry-admin__body"><div className="entry-admin__brand"><EntryBrand /><EntryDivider /></div><div className="entry-admin__panel entry-glass-panel entry-glass-panel--gold"><div className="entry-login__icon"><ShieldCheck /></div><h1>{title.includes("المدير") ? <><strong>{title.split(" ")[0]}</strong> {title.split(" ").slice(1).join(" ")}</> : title}</h1><p>{isSetup ? "أدخل كلمة المرور للوصول إلى لوحة التحكم." : "هذه أول مرة — قم بإنشاء كلمة المرور الرئيسية."}</p>{!loading && <form onSubmit={onSubmit} className="entry-admin__form" data-testid="admin-form"><PasswordField label="كلمة المرور" value={pw} onChange={setPw} show={show} setShow={setShow} testId="admin-password-input" autoFocus />{!isSetup && <PasswordField label="تأكيد كلمة المرور" value={pw2} onChange={setPw2} show={show} testId="admin-password-confirm" />}<button type="submit" disabled={submitting} className="entry-primary-button" data-testid="admin-submit"><KeyRound /><span>{submitting ? "جاري الدخول…" : isSetup ? "تسجيل الدخول" : "إنشاء كلمة المرور"}</span></button></form>}</div><p className="entry-copyright">© بنك العائلة — جميع الحقوق محفوظة</p></div></section></EntryVaultShell>;
}

function PasswordField({ label, value, onChange, show, setShow, testId, autoFocus = false }) {
  return <div className="entry-field"><label>{label}</label><div className="entry-input-wrap"><input type={show ? "text" : "password"} value={value} onChange={(event) => onChange(event.target.value)} autoFocus={autoFocus} autoComplete="current-password" className="entry-login-input" placeholder="••••••••" required data-testid={testId} />{setShow && <button type="button" onClick={() => setShow((state) => !state)} className="entry-password-toggle" data-testid="admin-toggle-show" aria-label={show ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}>{show ? <EyeOff /> : <Eye />}</button>}</div></div>;
}
